export default __webpack_public_path__ + "static/media/faq.9369018d.webp";